import {useEffect, useState} from "react";
import {Button} from '@common/ui/buttons/button';
import {FormTextField} from '@common/ui/forms/input-field/text-field/text-field';
import {Trans} from "@common/i18n/trans";
import {IconButton} from "@common/ui/buttons/icon-button";
import {DeleteOutlineIcon} from "@common/icons/material/DeleteOutline";
import {useFormContext} from "react-hook-form";

export function AssetsListForm({userAssets}: { userAssets: string[] }) {
  const {register, setValue} = useFormContext();
  const [entries, setEntries] = useState<string[]>([]);
  const [errors, setErrors] = useState<string[]>([]);

  useEffect(() => {
    if (userAssets && userAssets.length !== 0) {
      setEntries(userAssets);
    }
  }, []);
  useEffect(() => {
    setErrors([]);
    const nonBlankEntries = entries.filter(entry => entry.trim() !== ""); // Remove blank entries
    setValue("assets", nonBlankEntries);
  }, [entries]);

  const addEntry = () => {
    const newErrors: string[] = [];
    entries.forEach((entry, index) => {
      if (!entry.trim()) {
        newErrors[index] = "Please enter the name of the asset";
      }
    })
    if (newErrors.length > 0) {
      setErrors(newErrors);
    } else {
      setEntries([...entries, ""]);
    }
  };

  const removeEntry = (index: number) => {
    setEntries(entries.filter((_, i) => i !== index));
  };

  const updateEntry = (index: number, value: string) => {
    const newEntries = [...entries];
    newEntries[index] = value;
    setEntries(newEntries);
  };

  return (
    <div>
      <div className="mb-5 mt-20 text-base bold text-muted">
        <strong><Trans message="LIST OF OTHER ASSETS"/></strong>
      </div>
      <div className="mb-5 text-base text-muted">
        List your other assets and heirlooms here
      </div>
      <br/>
      {entries.map((entry, index) => (
        <div key={index} >
          {errors[index] && <div className=" text-sm text-danger"><Trans message={errors[index]}/></div>}
          <div className="flex items-center gap-2 mb-4">
            <FormTextField
              className="flex-1"
              {...register(`assets.${index}`)}
              value={entry}
              onChange={(e) => updateEntry(index, e.target.value)}
            />
            <IconButton onClick={() => removeEntry(index)}>
              <DeleteOutlineIcon/>
            </IconButton>
          </div>
        </div>
      ))}
      <Button variant="outline" onClick={addEntry}>Add Entry</Button>
    </div>
  );
}